import { render, staticRenderFns } from "./entity-picker.vue?vue&type=template&id=52cf2b85&scoped=true&"
import script from "./entity-picker.vue?vue&type=script&lang=js&"
export * from "./entity-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf2b85",
  null
  
)

export default component.exports